import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { SummaryEnvironmentComponent } from './summary-environment.component';

@NgModule({
    imports: [SharedModule],
    declarations: [SummaryEnvironmentComponent],
    entryComponents: [SummaryEnvironmentComponent],
    exports: [SummaryEnvironmentComponent]
})
export class SummaryEnvironmentModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/summary-environment/summary-environment.module.ts